export const STATUSDRAFT = 'draft';
export const STATUSACTIVE = 'active';
